import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	issueTypeFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teamFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelsFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	savedFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceValueEmptyError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypeFieldLabelIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	issueTypeFieldLabel: {
		id: 'software-board-create.modal.form.source-value-picker.issue-type-field-label',
		defaultMessage: 'Issue type',
		description: 'Label for the issue types field',
	},
	teamFieldLabel: {
		id: 'software-board-create.modal.form.source-value-picker.team-field-label',
		defaultMessage: 'Team',
		description: 'Label for the team field',
	},
	labelsFieldLabel: {
		id: 'software-board-create.modal.form.source-value-picker.labels-field-label',
		defaultMessage: 'Label',
		description: 'Label for the labels field',
	},
	savedFilterLabel: {
		id: 'software-board-create.modal.form.source-value-picker.saved-filter-label',
		defaultMessage: 'Select a saved filter',
		description: 'Label for the saved filter picker',
	},
	sourceValueEmptyError: {
		id: 'software-board-create.modal.form.source-value-picker.source-value-empty-error',
		defaultMessage: 'Please select a value',
		description: 'Error message for when the source value is empty',
	},
	issueTypeFieldLabelIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-value-picker.issue-type-field-label-issue-terminology-refresh-m4',
		defaultMessage: 'Work type',
		description: 'Label for the issue types field',
	},
});
export default messages;
